<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">AS ALWAYS,</span> thank you to my beta team. Your eyes see so much.</p>
<p class="P_Normal">But special thanks to my husband, Andrew. There is so much of you in this book—your ideas for the plot, dialogue, intrigue, humor…. I couldn’t have written this one without you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?4982dc6d